import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { initialize, Field, reduxForm } from "redux-form";
import { Button, ProgressIndicator, ReduxControls } from "rhombus-react";
import PropTypes from "prop-types";

import { fetchLibraryContentFeeds, assignExistingContentFeed } from "reducers/AssignContentFeed";
import { required } from "forms/validators/validators";
import { noop } from "utils/common";
import BasicModal from "widgets/modals/BasicModal";
import { loadCreatives } from "reducers/Creatives";

import "./AssignExistingContentFeed.css";

const ASSIGN_EXISTING_CONTENT_FEEDS_FORM = "assign-existing-content-feeds-form";

function AssignExistingContentFeed(props) {
	const dispatch = useDispatch();
	const {
		creativeIds,
		creativeName,
		handleSubmit,
		submitting,
		invalid,
		libraryId,
		onClose,
	} = props;

	const [contentFeeds, setContentFeeds] = useState([]);
	const [isLoadingFeeds, setIsLoadingFeeds] = useState(true);

	const targetCreativeIds = creativeIds || [];

	const submitFunction = (values, dispatchParam) => {
		const { contentFeedId, creativeIds, libraryId } = values;
		return dispatchParam(assignExistingContentFeed(creativeIds, contentFeedId?.value, libraryId))
			.then((resp) => {
				if (resp?.success) {
					dispatchParam(loadCreatives(libraryId));
					onClose();
				}
			});
	};

	useEffect(() => {
		setIsLoadingFeeds(true);
		dispatch(fetchLibraryContentFeeds(libraryId))
			.then((resp) => {
				if (resp?.success && resp.payload?.data?.items) {
					setContentFeeds(
						resp.payload.data.items.map(feed => ({
							label: feed.name || feed.url,
							value: feed.id,
						}))
					);
				}
			})
			.finally(() => setIsLoadingFeeds(false));

		dispatch(initialize(ASSIGN_EXISTING_CONTENT_FEEDS_FORM, {
			creativeIds: targetCreativeIds,
			libraryId,
		}));
	}, []);

	const renderContent = () => (
		<div className="assign-existing-content-feed-container">
			<ProgressIndicator isLoading={submitting || isLoadingFeeds} />
			<form className="assign-existing-content-feed-form" onSubmit={handleSubmit(submitFunction)}
				  id={ASSIGN_EXISTING_CONTENT_FEEDS_FORM}>
				<div className="assign-content-feed-form-field assign-content-feed-form-last-field">
					<Field
						name="contentFeedId"
						label="Bulk Sheet"
						component={ReduxControls.Select}
						options={contentFeeds}
						placeholder="Select Bulk Sheet"
						isClearable={false}
						required
						validate={[required]}
						onMenuScrollToBottom={noop}
					/>
				</div>
			</form>
		</div>
	);

	const renderFooter = () => ([
		<Button key="close" theme="grey" disabled={submitting} onClick={onClose}>Close</Button>,
		<Button
			key="submit"
			theme="blue"
			disabled={submitting || invalid || isLoadingFeeds}
			type="submit"
			form={ASSIGN_EXISTING_CONTENT_FEEDS_FORM}
		>
			Assign Bulk Sheet
		</Button>
	]);

	const modalProps = {
		title: `Assign Existing Bulk Sheet - ${creativeName}`,
		onClose,
		renderContent,
		renderFooter,
	};

	return <BasicModal {...modalProps} />;
}

AssignExistingContentFeed.propTypes = {
	creativeIds: PropTypes.arrayOf(PropTypes.number).isRequired,
	creativeName: PropTypes.string.isRequired,
	libraryId: PropTypes.number.isRequired,
	onClose: PropTypes.func.isRequired,
};

AssignExistingContentFeed.displayName = "AssignExistingContentFeed";

export default reduxForm({
	form: ASSIGN_EXISTING_CONTENT_FEEDS_FORM,
})(AssignExistingContentFeed);
